document.addEventListener('DOMContentLoaded', () => {

  const qtyInput = document.querySelector('.quantity__input');
  const hiddenVariants = document.querySelectorAll('.hidden-variant-options input[name="qty_variant"]');
  const productForm = document.querySelector('form[action*="/cart/add"].form');
  const variantIdInput = productForm?.querySelector('input[name="id"]');
  const priceRegular = document.querySelector('.price .price-item--regular');
  const priceSale = document.querySelector('.price .price-item--sale');
  const saleContainer = document.querySelector('.price__sale');
  const callBtn = document.querySelector('.call-inquiry-btn');
  const addToCartBtn = document.querySelector('.product-form__submit');
  const each = document.querySelector('.each');
  const priceWrap = document.querySelector('.price_wrap');

  const inquiryMessage = 'For pricing on 15 or more books, please contact us';

  if (!qtyInput || !hiddenVariants.length || !variantIdInput) {
    console.warn('[Qty→Variant] Missing required elements.');
    return;
  }

  const formatCurrency = value =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: Shopify.currency.active
    }).format(value);

  // ✅ Supports "1-2", "3", and "36+"
  function parseRange(title) {
    title = title.trim();

    const rangeMatch = title.match(/(\d+)\s*-\s*(\d+)/);
    if (rangeMatch) {
      return { min: +rangeMatch[1], max: +rangeMatch[2] };
    }

    const plusMatch = title.match(/^(\d+)\s*\+$/);
    if (plusMatch) {
      return { min: +plusMatch[1], max: Infinity };
    }

    const singleMatch = title.match(/^(\d+)$/);
    if (singleMatch) {
      const val = +singleMatch[1];
      return { min: val, max: val };
    }

    return null;
  }

  // ✅ Now checks for availability
  function findVariantForQuantity(qty) {
    let lastAvailable = null;
    for (const input of hiddenVariants) {
      const range = parseRange(input.dataset.title);
      const isAvailable = input.dataset.available === 'true';

      if (!range) continue;
      if (isAvailable) lastAvailable = input;

      if (isAvailable && qty >= range.min && qty <= range.max) {
        return input;
      }
    }
    return lastAvailable; // keep last available variant
  }

  function updatePriceDisplay(price, compareAt) {
    if (!priceRegular) return;

    if (compareAt && compareAt > price) {
      saleContainer?.classList.add('price--on-sale');
      priceRegular.textContent = formatCurrency(compareAt);
      priceSale.textContent = formatCurrency(price);
      saleContainer.style.display = 'block';
    } else {
      saleContainer?.classList.remove('price--on-sale');
      priceRegular.textContent = formatCurrency(price);
      if (priceSale) priceSale.textContent = '';
      saleContainer.style.display = 'none';
    }
  }

  function showInquiryMode() {
    if (callBtn) callBtn.classList.remove('hidden');
    if (addToCartBtn) addToCartBtn.style.display = 'none';
    if (priceWrap) priceWrap.style.display = 'none';
    if (priceRegular) priceRegular.textContent = '';
    if (each) each.style.display = 'none';
    if (saleContainer) saleContainer.style.display = 'none';
  }

  function hideInquiryMode(price, compareAt) {
    if (callBtn) callBtn.classList.add('hidden');
    if (addToCartBtn) addToCartBtn.style.display = '';
    if (priceWrap) priceWrap.style.display = '';
    if (each) each.style.display = '';
    updatePriceDisplay(price, compareAt);
  }

  function handleQtyChange() {
    const qty = parseInt(qtyInput.value, 10);
    if (isNaN(qty) || qty < 1) return;

    const match = findVariantForQuantity(qty);

    if (!match) {
      showInquiryMode(); // hide ATC and price if no available variant
      return;
    }

    hiddenVariants.forEach(v => (v.checked = false));
    match.checked = true;
    variantIdInput.value = match.value;
    const variantInput = productForm.querySelector('.product-variant-id');
    if (variantInput) variantInput.value = match.value;

    const price = parseFloat(match.dataset.price || 0);
    const compareAt = parseFloat(match.dataset.compareAt || 0);

    hideInquiryMode(price, compareAt);
  }

  productForm?.addEventListener('submit', e => {
    const qty = parseInt(qtyInput.value, 10);
    const match = findVariantForQuantity(qty);
    if (match) {
      variantIdInput.value = match.value;
      const variantInput = productForm.querySelector('.product-variant-id');
      if (variantInput) variantInput.value = match.value;
    }
  });

  qtyInput.addEventListener('input', handleQtyChange);
  document.querySelectorAll('.quantity__button').forEach(btn =>
    btn.addEventListener('click', () => setTimeout(handleQtyChange, 100))
  );

  handleQtyChange();
});
